
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class BranchInItemsGrid extends Serenity.EntityGrid<BranchInItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.BranchInItems'; }
        protected getDialogType() { return BranchInItemsDialog; }
        protected getIdProperty() { return BranchInItemsRow.idProperty; }
        protected getInsertPermission() { return BranchInItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return BranchInItemsRow.localTextPrefix; }
        protected getService() { return BranchInItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }
        
    }
}